import React, { useLayoutEffect, useRef, useState } from 'react';
import POS from '../../../index';
import styles from './style.less';

const UIPreview: React.FC = () => {
  const container = useRef<HTMLDivElement>();
  const [containerWidth, setContainerWidth] = useState<number>(0);

  useLayoutEffect(() => {
    if (container && container.current) {
      setContainerWidth(container.current.offsetWidth);
    }
  }, [container]);

  const checkoutAreaWidth = 310;
  const skuAreaWidth = window.innerWidth - checkoutAreaWidth;

  return (
    <div
      className={styles.previewContainer}
      ref={container}
      style={{ width: containerWidth ? containerWidth : 'auto' }}>
      {containerWidth < 1 && <>&nbsp;</>}
      {containerWidth > 0 && (
        <div
          className={styles.preview}
          style={{
            width: skuAreaWidth,
            transform: `scale(${containerWidth / skuAreaWidth})`,
          }}>
          <POS previewMode={true} previews={['skuArea']} />
        </div>
      )}
    </div>
  );
};

export default UIPreview;
